import { render, staticRenderFns } from "./internbudget.vue?vue&type=template&id=78e73746"
import script from "./internbudget.vue?vue&type=script&lang=js"
export * from "./internbudget.vue?vue&type=script&lang=js"
import style0 from "./internbudget.vue?vue&type=style&index=0&id=78e73746&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports